import React from 'react';
import Subscription from 'components/subscription/Subscription';

export default function PayAsYouGoStep({ handleComplete }) {
  return <Subscription />;
}
